import Vue from 'vue';
import { trackEvent } from '../../assets/js/lib/tracking';
import { A11y, Keyboard } from 'swiper/modules';

export default (el) =>
  new Vue({
    el,
    components: {
      'vue-swiper': () => import('../vue-swiper/vue-swiper.vue'),
    },
    name: 'Visual filters',
    data() {
      return {
        isActive: false,
        swiperOptions: {
          slidesPerView: 'auto',
          a11y: true,
          keyboard: true,
          modules: [A11y, Keyboard]
        }
      };
    },
    mounted() {
      window.addEventListener('searchspring.domReady', () => {
        setTimeout(() => {
          this.reRenderCarousel();
        }, 200);
        const target = document.querySelector(
          '.collection__filters__filter-btn',
        );
        target?.addEventListener('click', (e) => {
          this.toggleActive();
        });
      });
    },
    methods: {
      handleCollectionClick(url, value) {
        trackEvent({
          event: 'product_filter',
          filter_name: 'product type',
          filter_value: value,
          component_name: this.$el.dataset.componentName,
          site_section: this.$el.dataset.siteSection
        })

        location.href = url;
      },
      toggleActive() {
        this.isActive = !this.isActive;
        if (this.isActive) {
          setTimeout(() => {
            this.reRenderCarousel();
          }, 200);
        }
      },
      reRenderCarousel() {
        const { carousel } = this.$refs;
        this.$nextTick(() => {
          if (carousel) carousel.$swiper.update();
        });
      },
    },
  });
